<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="cog" />ข้อมูลพื้นฐานโครงการ
    </h6>

    <table class="table mb-0">
      <tbody>
        <tr>
          <td class="align-middle">
            <strong>ชื่อโครงการ</strong>
            <span class="text-danger"> *</span>
          </td>
          <td class="align-middle">
            <b-form-input
              v-model="$v.value.name.$model"
              :state="$v.value.name.$dirty ? !$v.value.name.$error : null"
            />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>หน่วยงานที่รับผิดชอบ</strong>
          </td>
          <td class="align-middle">
            {{ value.group.name }}
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ปีการศึกษา</strong>
            <span class="text-danger"> *</span>
          </td>
          <td class="align-middle">
            <b-form-select
              v-model="$v.value.acYearId.$model"
              :options="acYearOptions"
              :state="$v.value.acYearId.$dirty ? !$v.value.acYearId.$error : null"
            />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ที่ปรึกษา</strong>
            <p>ข้อมูลอัตโนมัติจากหน่วยงานที่รับผิดชอบ</p>
          </td>
          <td class="align-middle">
            {{ value.advisor.name }} {{ value.advisor.tel ? '(โทร ' + value.advisor.tel + ')' : '' }}
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ประธานโครงการ</strong>
            <span class="text-danger"> *</span>
          </td>
          <td class="align-middle">
            <div v-if="project.leader.username" class="mb-2">
              {{ project.leader.name }} <template v-if="project.leader.tel">(โทร {{ project.leader.tel }})</template>
            </div>

            <b-button v-b-modal.leader-user-lookup-modal variant="primary" size="sm"><font-awesome-icon icon="user-edit" />กำหนดประธานโครงการ</b-button>
            <leader-user-lookup-modal />
          </td>
        </tr>
        <tr>
          <td>
            <strong>ผู้ประสานงานโครงการ</strong>
          </td>
          <td class="align-middle">
            <coordinators-table v-model="value.coordinators" />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>อาจารย์ผู้ดูแลโครงการ</strong>
            <p>กรณีที่ผู้ดูแลโครงการไม่ใช่อาจารย์ที่ปรึกษา</p>
          </td>
          <td class="align-middle">
            <b-form-input v-model.trim="value.personInCharge" />
          </td>
        </tr>
        <tr>
          <td>
            <strong>หลักการและเหตุผล</strong>
          </td>
          <td class="align-middle">
            <b-textarea v-model.trim="value.background" rows="5" />
          </td>
        </tr>
        <tr>
          <td>
            <strong>วัตถุประสงค์</strong>
          </td>
          <td class="align-middle">
            <objective-list v-model="value.objectives" />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>สถานที่จัดโครงการ</strong>
          </td>
          <td class="align-middle">
            <venue-list v-model="value.venue" />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>วันจัดโครงการ</strong>
            <p>กรณีจัดโครงการเพียงหนึ่งวัน ให้เลือกวันเริ่มต้นและวันสิ้นสุดเป็นวันเดียวกัน</p>
          </td>
          <td class="align-middle">
            <v-date-picker v-model="value.timeframeRaw" :columns="2" :popover="{ visibility: 'click' }" color="orange" locale="th" mode="range" />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ผู้เข้าร่วมโครงการ</strong>
          </td>
          <td class="align-middle">
            <div class="row">
              <div class="col">
                <b-input-group size="sm" prepend="อาจารย์/เจ้าหน้าที่" append="คน">
                  <b-form-input
                    v-model.number="$v.value.attendee.instructor.$model"
                    :state="$v.value.attendee.instructor.$dirty ? !$v.value.attendee.instructor.$error : null"
                    class="text-center"
                    type="number"
                    min="0"
                  />
                </b-input-group>
                <b-form-text id="input-live-help">กรอกเป็นตัวเลขเท่านั้น หากประเภทใดไม่มีผู้เข้าร่วมให้กรอก 0</b-form-text>
              </div>
              <div class="col">
                <b-input-group size="sm" prepend="นักศึกษา" append="คน">
                  <b-form-input
                    v-model.number="$v.value.attendee.student.$model"
                    :state="$v.value.attendee.student.$dirty ? !$v.value.attendee.student.$error : null"
                    class="text-center"
                    type="number"
                    min="0"
                  />
                </b-input-group>
              </div>
              <div class="col">
                <b-input-group size="sm" prepend="บุคคลภายนอก" append="คน">
                  <b-form-input
                    v-model.number="$v.value.attendee.others.$model"
                    :state="$v.value.attendee.others.$dirty ? !$v.value.attendee.others.$error : null"
                    class="text-center"
                    type="number"
                    min="0"
                  />
                </b-input-group>
              </div>
              <div class="col">
                <b-input-group size="sm" prepend="รวมทั้งสิ้น" append="คน">
                  <b-form-input class="text-center" :value="totalAttendee" disabled />
                </b-input-group>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import CoordinatorsTable from '../CoordinatorTable'
import ObjectiveList from '../ObjectiveList'
import VenueList from '../VenueList'
import LeaderUserLookupModal from '../leaderUserLookupModal'

import gql from 'graphql-tag'
import ProjectEditValidatorMixins from '@/mixins/projectEditValidatorMixins'
import { required, numeric, minValue } from 'vuelidate/lib/validators'

export default {
  components: {
    CoordinatorsTable, ObjectiveList, VenueList, LeaderUserLookupModal
  },
  mixins: [
    ProjectEditValidatorMixins
  ],
  props: {
    value: { type: Object, required: true }
  },
  apollo: {
    acYears: {
      query: gql`{ acYears(page:1, count:100) { data { id, year, startAt, endAt } } }`,
      fetchPolicy: 'no-cache'
    }
  },
  data () {
    return {
      acYears: { data: [] }
    }
  },
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) },
    totalAttendee () {
      return this.value.attendee.instructor + this.value.attendee.student + this.value.attendee.others
    },
    acYearOptions () {
      return this.acYears.data.map(year => ({ text: 'ปีการศึกษา ' + year.year, value: year.id }))
    }
  },
  validations: {
    value: {
      name: { required },
      acYearId: { required },
      attendee: {
        instructor: { required, numeric, minValue: minValue(0) },
        student: { required, numeric, minValue: minValue(0) },
        others: { required, numeric, minValue: minValue(0) }
      }
    }
  },
  methods: {
    onTimeframeChange (date) {
      this.value.timeframe = date
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 220px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
